var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"bg-center pt-64 absolute w-screen md:bg-cover md:bg-center left-1/2 transform -translate-x-1/2",style:({
    backgroundImage: ("url('" + _vm.bannerPhoto + "')"),
  })})}
var staticRenderFns = []

export { render, staticRenderFns }